import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CloseIcon from "../../../assets/icons/close.svg";
import APIVariables from "../../../services/api-variables";
import StyledRegister from "../../authentication/StyledRegister";
import { handleCatch, isObject } from "../../../shared/helpers";
import { App } from "../../../routes/Constants";
import Loader from "../../common/Loader/Loader";
import { errorMessages } from "../../../constants/errorMessages.constants";
import RemoveConnectedPharmacistModal from "./modals/RemoveConPharmModal";
import useRoles from "../../../hooks/useRoles";
import QuitModal from "../../common/Modal/QuitModal";
import Axios from "../../../services/Axios";

const ConnectedPharmacistView = () => {
  const navigate = useNavigate();

  const selectedConnectedPharmacist = window.location.pathname.split("/")[2];
  const [form, setForm] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [modalIsOpen, setIsModalOpen] = useState(false);
  const { storageData } = useRoles();
  const [quitModalIsOpen, setIsOpenQuit] = useState(false);

  useEffect(() => {
    getData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getData = async () => {
    await Axios.get(
      APIVariables.HCP_CON_PHARMACIST + selectedConnectedPharmacist
    )
      .then((res) => {
        const { status, data } = res;
        if (status === 200) {
          setForm(data);
        }
      })
      .catch((error) => {
        handleCatch(error);
      });

    setIsLoading(false);
  };

  const openModalRemoveCP = (e) => {
    e.stopPropagation();
    setIsModalOpen(true);
  };

  const removeCP = async () => {
    setErrorMessage("");

    await Axios.delete(
      APIVariables.HCP_CON_PHARMACIST + selectedConnectedPharmacist
    )
      .then((res) => {
        const { status } = res;
        if (status === 200) {
          closeModal();
          navigate(App.CONNECTED_PHARMACISTS);
        }
      })
      .catch(function (error) {
        const errors = error.response.data;
        if (typeof errors === "string") {
          setErrorMessage([errorMessages.INTERNAL_SERVER_ERROR]);
        } else {
          const errorsArray = [];
          Object.keys(errors).forEach((key) => {
            if (isObject(errors[key])) {
              Object.keys(errors[key]).forEach((secondKey) => {
                errorsArray.push(key + " - " + errors[key][secondKey][0]);
              });
            } else {
              errorsArray.push(key + " - " + errors[key]);
            }
          });
          setErrorMessage(errorsArray);
        }
      });
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  function closeForm() {
    setIsOpenQuit(true);
  }
  function closeModalQuit() {
    setIsOpenQuit(false);
  }
  function quitModal() {
    navigate(App.CONNECTED_PHARMACISTS);
  }

  if (isLoading) return <Loader />;
  return (
    <React.Fragment>
      <StyledRegister>
        <React.Fragment>
          <div className="layout-modal">
            <div className="close-icon" onClick={closeForm}>
              <img src={CloseIcon} alt="Close Icon" />
            </div>
            <div className="title-flex">
              <h1 className="select-category-txt mineShaft-color">
                {`${form?.first_name} ${form?.last_name}`} - Pharmacist
              </h1>
              <div className="title-flex">
                <button
                  className="second-button red-button"
                  onClick={(e) => openModalRemoveCP(e)}
                >
                  Remove
                </button>
              </div>
            </div>
            <hr className="gray-hr" />

            <h2 className={"title-details"}>Pharmacist Details</h2>
            <div className="container mb-5">
              <div className="row">
                <div className="col">
                  <label>Pharmacist First Name:</label>
                  <input
                    type="text"
                    name="first_name"
                    value={form?.first_name || ""}
                    disabled
                  />
                </div>
                <div className="col">
                  <label>Pharmacist Last Name:</label>
                  <input
                    type="text"
                    name="last_name"
                    value={form?.last_name || ""}
                    disabled
                  />
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <label>GPhC / PSNI Registration Number:</label>
                  <input
                    type="text"
                    value={form?.registration_number || ""}
                    disabled
                  />
                </div>
                <div className="col">
                  <label>Job Title:</label>
                  <input
                    type="text"
                    name="job_title"
                    value={form?.job_title || ""}
                    disabled
                  />
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <label>Pharmacy Name:</label>
                  <input
                    type="text"
                    name="email"
                    value={storageData?.pharmacy?.value || ""}
                    disabled
                  />
                </div>
                <div className="col">
                  <label>
                    Email Address: (A link will be sent to verify your email
                    address)
                  </label>
                  <input
                    type="text"
                    name="email"
                    value={form?.email || ""}
                    disabled
                  />
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <label>Pharmacy address:</label>
                  <input
                    type="text"
                    value={storageData?.pharmacy?.address || ""}
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>
          {quitModalIsOpen && (
            <QuitModal
              quitModalIsOpen={quitModalIsOpen}
              closeModalQuit={closeModalQuit}
              quitModal={quitModal}
              description="Are you sure you want to cancel filling out this Form. All progress will be lost and you will need to start again."
            />
          )}
          {modalIsOpen && (
            <RemoveConnectedPharmacistModal
              modalIsOpen={modalIsOpen}
              closeModal={closeModal}
              removePharmacist={removeCP}
              errorMessage={errorMessage}
            />
          )}
        </React.Fragment>
      </StyledRegister>
    </React.Fragment>
  );
};
export default ConnectedPharmacistView;
